module.exports = __webpack_public_path__ + "img/pic5.0c8fe77c.png";